interface UpdateItem {
  date: string;
  title: string;
  desc: string;
  badge?: string;
}

const updates: UpdateItem[] = [
  {
    date: '2026.07.28',
    title: '《霸道总裁的契约新娘》第128话更新',
    desc: '本季最受瞩目的韩漫神作迎来关键剧情转折，男女主角终于坦诚相见。',
    badge: 'NEW',
  },
  {
    date: '2026.07.27',
    title: '贝勒漫画APP v3.8.2 版本发布',
    desc: '新增智能推荐算法，优化离线下载速度，修复部分机型闪退问题。',
  },
  {
    date: '2026.07.26',
    title: '《剑道至尊》突破1000万阅读量',
    desc: '这部国漫大作凭借精湛画风和硬核剧情，成为近期讨论度最高的作品之一。',
  },
  {
    date: '2026.07.25',
    title: '暑期漫画狂欢季活动上线',
    desc: '全场热门漫画限时免费阅读，新用户注册即送30天VIP体验权益。',
    badge: '热门',
  },
  {
    date: '2026.07.24',
    title: '韩漫专区新增12部独家引进作品',
    desc: '涵盖恋爱、奇幻、悬疑等热门题材，均为国内首次正版授权的精品韩漫。',
  },
  {
    date: '2026.07.23',
    title: '《放学后的秘密》动画化决定',
    desc: '这部校园纯爱日漫力作正式宣布动画化制作，预计明年春季开播。',
  },
  {
    date: '2026.07.22',
    title: '网站服务器全面升级完成',
    desc: '阅读加载速度提升40%，高峰期访问更流畅，图片清晰度全面优化。',
  },
  {
    date: '2026.07.21',
    title: '日漫专区上线《咒术战线》全集',
    desc: '现象级日漫作品全集一次性上线，支持高清画质和多种阅读模式切换。',
  },
  {
    date: '2026.07.20',
    title: '贝勒漫画读者社区功能上线',
    desc: '全新读者互动社区正式开放，支持漫画点评、同好交流和创作分享。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">最新动态</h2>
          <p className="text-sm text-foreground-500">贝勒漫画最新资讯与更新，时刻掌握热门动态</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-0">
            <div className="absolute left-3 md:left-4 top-2 bottom-2 w-px bg-background-300"></div>

            <div className="space-y-6">
              {updates.map((item, idx) => (
                <div key={idx} className="relative pl-8 md:pl-10">
                  <div className="absolute left-0 md:left-2 top-1.5 w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-100"></div>
                  <div className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/60 hover:border-primary-200/60 transition-colors cursor-pointer">
                    <div className="flex items-center gap-2 mb-1.5">
                      <time className="text-xs text-foreground-400 font-mono">{item.date}</time>
                      {item.badge && (
                        <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-accent-100 text-accent-700">
                          {item.badge}
                        </span>
                      )}
                    </div>
                    <h3 className="text-sm font-medium text-foreground-900 mb-1">{item.title}</h3>
                    <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}